export const TRAINING_KPI_PAGE_CLASS = "training-kpi-page";
export const TRAINING_KPI_PANEL = "training-kpi-panel";
export const TRAINING_KPI_TABLE = "training-kpi-table";

